import { render, staticRenderFns } from "./BannerVideo.vue?vue&type=template&id=40ea6f16&"
import script from "./BannerVideo.vue?vue&type=script&lang=js&"
export * from "./BannerVideo.vue?vue&type=script&lang=js&"
import style0 from "./BannerVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VResponsive } from 'vuetify/lib/components/VResponsive';
installComponents(component, {VResponsive})
